import React from 'react';

export const CheckBoxIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.147 3.0876C12.3748 3.31541 12.3748 3.68475 12.147 3.91256L5.73035 10.3292C5.50254 10.557 5.1332 10.557 4.90539 10.3292L1.98873 7.41256C1.76092 7.18475 1.76092 6.81541 1.98873 6.5876C2.21653 6.3598 2.58588 6.3598 2.81368 6.5876L5.31787 9.09179L11.3221 3.0876C11.5499 2.8598 11.9192 2.8598 12.147 3.0876Z"
      fill="var(--color-text-primary-alt)"
    />
  </svg>
);
